import { Alert, Button } from '@components'
import { getBankIntegrationPageURL } from '@constants'
import { useBusinessContext } from '@context'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { FaCheck } from 'react-icons/fa'
import { useHistory } from 'react-router-dom'
import styled from 'styled-components'

export const ConnectBankAlert: React.FC = () => {
  const [t] = useTranslation()
  const history = useHistory()
  const { slug } = useBusinessContext()

  return (
    <Alert
      type="info"
      title={t('settings.invoicing.bankAccount.connect.title')}
      description={
        <ConnectBankContent>
          <ConnectBankList>
            <ConnectBankItem>
              <CheckMark>
                <FaCheck />
              </CheckMark>
              <span>{t('settings.invoicing.bankAccount.connect.paid')}</span>
            </ConnectBankItem>
            <ConnectBankItem>
              <CheckMark>
                <FaCheck />
              </CheckMark>
              <span>{t('settings.invoicing.bankAccount.connect.autofill')}</span>
            </ConnectBankItem>
            <ConnectBankItem>
              <CheckMark>
                <FaCheck />
              </CheckMark>
              <span>{t('settings.invoicing.bankAccount.connect.suggestions')}</span>
            </ConnectBankItem>
          </ConnectBankList>
          <Button
            type="button"
            size="sm"
            intent="primary"
            onClick={() => history.push(getBankIntegrationPageURL(slug, 'aspsps'))}
          >
            {t('settings.invoicing.bankAccount.connect.button')}
          </Button>
        </ConnectBankContent>
      }
    />
  )
}

const ConnectBankContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.md}rem;
  margin-top: ${({ theme }) => theme.spacing.xs}rem;
  /* Hang the checks and button under the title, past the info icon. */
  padding-left: calc(
    ${({ theme }) => theme.fontSize.md}rem + ${({ theme }) => theme.spacing.xs}rem
  );
`

const ConnectBankList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing.sm}rem;
`

const ConnectBankItem = styled.li`
  display: flex;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing.md}rem;
`

const CheckMark = styled.span`
  display: inline-flex;
  flex-shrink: 0;
  margin-top: 0.15rem;
  color: ${({ theme }) => theme.colors.success};

  && svg {
    width: ${({ theme }) => theme.fontSize.xs}rem;
    height: ${({ theme }) => theme.fontSize.xs}rem;
    min-width: ${({ theme }) => theme.fontSize.xs}rem;
    min-height: ${({ theme }) => theme.fontSize.xs}rem;
    fill: currentColor;
  }
`
